import 'leaflet';
const version = '0.0.1';

class MapInstanceTerritories{
    static init(element){
        var $element = $(element);
        if($element.data('map-instance')){
            return $element.data('map-instance');
        }else{
            let instance = new MapInstanceTerritories(element)
            $element.data('map-instance', instance);
            return instance
        }
    }

    constructor(element) {
        this.$element = $(element);
        this.element = element;
        //console.log('MapInstanceTerritories('+version+') init for: ', this.element);
        this.initMap();
    }

    initMap(){
        this.map = L.map('map', {
            scrollWheelZoom: false,
            zoomControl: false,
            fullscreenControl: true
        });
        this.mapObject = L.map('map_object', {
            scrollWheelZoom: false,
            zoomControl: false,
            fullscreenControl: true
        });

        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);
        L.control.zoom({
            position: 'topright'
        }).addTo(this.mapObject);

        this.renderer = L.canvas({ padding: 0.5 });
        this.rendererObject = L.canvas({ padding: 0.5 });
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png").addTo(this.map);
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png").addTo(this.mapObject);

        this.map.setView([54.9003, 23.9333], 8);
        this.mapObject.setView([54.9003, 23.9333], 8);
        this.loadAllTerritories(this.$element.data('id'));
        this.loadAllObjects(this.$element.data('id'));


        this.map.once('focus', function() {
            this.map.scrollWheelZoom.enable();
        }.bind(this));
        this.mapObject.once('focus', function() {
            this.mapObject.scrollWheelZoom.enable();
        }.bind(this));

        $('.m_location_t').click(function(e){
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                        var locationIcon = L.icon({
                            iconUrl: '/assets/images/map_icons/marker-icon.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                        });
                        this.map.setView([position.coords.latitude, position.coords.longitude], 8);
                        L.marker([position.coords.latitude, position.coords.longitude], {icon: locationIcon}).addTo(this.map);
                    }.bind(this),
                    function errorCallback(error) {
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                alert("User denied the request for Geolocation.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                alert("Location information is unavailable.");
                                break;
                            case error.TIMEOUT:
                                alert("The request to get user location timed out.");
                                break;
                            case error.UNKNOWN_ERROR:
                                alert("An unknown error occurred.");
                                break;
                        }
                    });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }.bind(this));
        $('.m_location_o').click(function(e){
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                        var locationIcon = L.icon({
                            iconUrl: '/assets/images/map_icons/marker-icon.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                        });
                        this.mapObject.setView([position.coords.latitude, position.coords.longitude], 8);
                        L.marker([position.coords.latitude, position.coords.longitude], {icon: locationIcon}).addTo(this.mapObject);
                    }.bind(this),
                    function errorCallback(error) {
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                alert("User denied the request for Geolocation.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                alert("Location information is unavailable.");
                                break;
                            case error.TIMEOUT:
                                alert("The request to get user location timed out.");
                                break;
                            case error.UNKNOWN_ERROR:
                                alert("An unknown error occurred.");
                                break;
                        }
                    });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }.bind(this));
    }

    loadAllTerritories(id){

        $.getJSON('/api/gis/territory', {id: id}).done(function (result){
            if(result.current)
            {
                L.geoJson(result.current, {
                    renderer: this.renderer,
                    style: {
                        color: result.current.properties.color,
                        fillColor: '#bddab3',
                        weight: 7
                    },
                    onEachFeature: function(feature, layer) {
                        layer.bindPopup(function(){
                            var popupContent = ''
                            $.ajax({
                                url: '/gis/popupData',
                                data: {id: feature.properties.id, type: 'Territories'},
                                async: false
                            }).done(function(data) {
                                popupContent =  data;
                            });

                            return popupContent;
                        }).bindTooltip(feature.properties.title, {permanent: true});
                    },
                }).addTo(this.map);

                L.geoJson(result.current, {
                    renderer: this.rendererObject,
                    style: {
                        color: result.current.properties.color,
                        fillColor: '#bddab3',
                        weight: 5
                    },
                    onEachFeature: function(feature, layer) {
                        layer.bindPopup(function(){
                            var popupContent = ''
                            $.ajax({
                                url: '/gis/popupData',
                                data: {id: feature.properties.id, type: 'Territories'},
                                async: false
                            }).done(function(data) {
                                popupContent =  data;
                            });

                            return popupContent;
                        }).bindTooltip(feature.properties.title, {permanent: true});
                    },
                }).addTo(this.mapObject);
            }

            var teritories = result.types;
            var $types = [];
            var $teritoryKinds = [];
            var allObjectTeritories = true;
            teritories.forEach(function (element, index){
                $types[element.id] = L.geoJson(result.geodata, {
                    renderer: this.renderer,
                    style: {
                        color: element.color
                    },
                    onEachFeature: function(feature, layer) {
                        layer.bindPopup(function(){
                            var popupContent = ''
                            $.ajax({
                                url: '/gis/popupData',
                                data: {id: feature.properties.id, type: 'Territories'},
                                async: false
                            }).done(function(data) {
                                popupContent =  data;
                            });

                            return popupContent;
                        });
                    },
                    filter: function(feature, layer) {
                        return feature.properties.type == element.id;
                    }
                });

                $teritoryKinds[element.id] = L.geoJson(result.geodata, {
                    renderer: this.rendererObject,
                    style: {
                        color: element.color
                    },
                    onEachFeature: function(feature, layer) {
                        layer.bindPopup(function(){
                            var popupContent = ''
                            $.ajax({
                                url: '/gis/popupData',
                                data: {id: feature.properties.id, type: 'Territories'},
                                async: false
                            }).done(function(data) {
                                popupContent =  data;
                            });

                            return popupContent;
                        });
                    },
                    filter: function(feature, layer) {
                        return feature.properties.type == element.id;
                    }
                });

                $types[element.id].addTo(this.map);
                $teritoryKinds[element.id].addTo(this.mapObject);
                this.mapObject.removeLayer($teritoryKinds[element.id]);

                $('#teritory-'+element.id).click(function(e) {
                    e.preventDefault();
                    if(allObjectTeritories){
                        allObjectTeritories = false;
                        $('#kind_filter a.territory_kind').addClass('opacity');
                        $types.forEach(function (item, index) {
                            this.map.removeLayer(item);
                        }.bind(this));
                    }
                    $('#teritory-' + element.id).toggleClass('opacity');

                    if (this.map.hasLayer($types[element.id])) {
                        this.map.removeLayer($types[element.id]);
                    } else {
                        this.map.addLayer($types[element.id])
                    }
                }.bind(this));

                $('#teritoryObject-'+element.id).click(function(e) {
                    e.preventDefault();
                    $('#teritoryObject-' + element.id).toggleClass('opacity');

                    if (this.mapObject.hasLayer($teritoryKinds[element.id])) {
                        this.mapObject.removeLayer($teritoryKinds[element.id]);
                    } else {
                        this.mapObject.addLayer($teritoryKinds[element.id])
                    }
                }.bind(this));
            }.bind(this));
            if(result.map_center)
            {
                this.map.setView([result.map_center.longitude, result.map_center.latitude], 10);
                this.mapObject.setView([result.map_center.longitude, result.map_center.latitude], 10);
            }
        }.bind(this))
    }

    loadAllObjects(id){
        $.get('/api/gis/territory_objects', {territory: id}).done(function (result){
            var kind = result.kinds;
            var type = result.types;

            var $kinds = [];
            var $types = [];
            var allTeritoriesObject = true;
            var $kindMarker = [];
            kind.forEach(function (element){
                $kindMarker[element.id] = L.icon({
                    iconUrl: element.icon,
                    iconSize:     [20, 20], // size of the icon
                    iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
                });
                $kinds[element.id] = L.geoJson(result.geodataKinds, {
                    renderer: this.renderer,
                    filter: function(feature, layer) {
                        return feature.properties.kind == element.id;
                    },
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: $kindMarker[element.id]}
                        ).on('click', function() {
                            var that = this;
                            $.get('/gis/popupData', {
                                id: feature.properties.id,
                                type: 'Objects'
                            }).done(function (result){
                                if (result) {
                                    that.bindPopup(result).openPopup();
                                }
                            });
                        });
                    }
                });
                $kinds[element.id].addTo(this.map);
                $('#objectkinds-' + element.id).click(function (e) {
                    e.preventDefault();
                    if(allTeritoriesObject){
                        allTeritoriesObject = false;
                        $('#kind_filter a').not('.territory_kind').addClass('opacity');
                        $kinds.forEach(function (item, index) {
                            this.map.removeLayer(item);
                        }.bind(this));
                    }
                    $('#objectkinds-' + element.id).toggleClass('opacity');

                    if (this.map.hasLayer($kinds[element.id])) {
                        this.map.removeLayer($kinds[element.id]);
                    } else {
                        this.map.addLayer($kinds[element.id])
                    }
                }.bind(this));
            }.bind(this));

            var $typeMarker = [];
            var allTypesActive = true;
            type.forEach(function (element){
                $typeMarker[element.id] = L.icon({
                    iconUrl: element.icon,
                    iconSize:     [20, 20], // size of the icon
                    iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
                });
                $types[element.id] = L.geoJson(result.geodata, {
                    renderer: this.rendererObject,
                    filter: function(feature, layer) {
                        return feature.properties.type == element.id;
                    },
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: $typeMarker[element.id]}
                        ).on('click', function() {
                            var that = this;
                            $.get('/gis/popupData', {
                                id: feature.properties.id,
                                type: 'Objects'
                            }).done(function (result){
                                if (result) {
                                    that.bindPopup(result).openPopup();
                                }
                            });
                        });
                    }
                });
                $types[element.id].addTo(this.mapObject);
                $('#objecttypes-' + element.id).click(function (e) {
                    e.preventDefault();
                    if(allTypesActive){
                        allTypesActive = false;
                        $('#type_filter a').not('.territory_type').addClass('opacity');
                        $types.forEach(function (item, index) {
                            this.mapObject.removeLayer(item);
                        }.bind(this));
                    }
                    $('#objecttypes-' + element.id).toggleClass('opacity');

                    if (this.mapObject.hasLayer($types[element.id])) {
                        this.mapObject.removeLayer($types[element.id]);
                    } else {
                        this.mapObject.addLayer($types[element.id])
                    }
                }.bind(this));
            }.bind(this));
        }.bind(this))
    }
}

export default MapInstanceTerritories;

$(function(){
    $('button[data-bs-target="#apie"]').click(function(){
        $('#kind_filter').show();
        $('#type_filter').hide();
        location.hash = '#apie';
    });
    $('button[data-bs-target="#lankytojams"]').click(function(){
        $('#kind_filter').hide();
        $('#type_filter').show();
        location.hash = '#lankytojams';
    });

    $('#toggle_map_filter').click(function(e){
        e.preventDefault();
        $('#map_filter').toggleClass('active');
    });
});